import React from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import Article from '../../../article/Article'
import articlesData from '../../../../mocks/articles.json'
import { getFeaturedArticles } from '../../../../utilities/articles'
import './publications-articles.css'

export default function PublicationsArticles() {
  const recentArticles = getFeaturedArticles(articlesData.Articles)

  return (
    <section className='publications-articles section__padding'>
      <Container>
        <h2 className='publications-section__title'>Artículos</h2>
        <p className='publications-articles__intro'>
          Artículos, entrevistas y colaboraciones sobre salud menstrual, climaterio, educación y transformación social.
        </p>
        
        <Row className='g-4 mb-4'>
          {recentArticles.map((article) => (
            <Col key={article.id} md={6} lg={4} className='mb-3'>
              <Article 
                imgUrl={article.imgUrl}
                title={article.title}
                url={article.url}
                category={article.category}
                date={article.date}
              />
            </Col>
          ))}
        </Row>

        <div className='publications-articles__footer'>
          <LinkContainer to='/articulos'>
            <Button className='publications-articles__button'>
              Ver todos los artículos
            </Button>
          </LinkContainer>
        </div>
      </Container>
    </section>
  )
}
